import { RootStore } from './RootStore';

export { default as RootStore } from './RootStore';
export { default as UserStore } from './UserStore';
export { default as StatusStore } from './StatusStore';
export { default as AddressStore } from './AddressStore';
export { default as ClassificationStore } from './ClassificationStore';
export { default as SearchSortStore } from './SearchSortStore';

var store: RootStore = new RootStore();

export default store;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/index.ts